import { render, staticRenderFns } from "./ListaODT.vue?vue&type=template&id=1d7b8e50&"
import script from "./ListaODT.vue?vue&type=script&lang=js&"
export * from "./ListaODT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports